import styled from "styled-components";

export const NewContainer = styled.div`
    width: 100%;
    text-decoration: none !important;
    background: white;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transition: var(--transition);
    box-shadow: var(--shadow-sm);
    height: 100%;

    &:hover {
        transform: translateY(-4px);
        box-shadow: var(--shadow-md);
        border-color: var(--color-primary-light);
    }
`;

export const ImgWrap = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    overflow: hidden;
    background: var(--color-bg-soft);
`;

export const ImgContainer = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 350ms ease;

    ${NewContainer}:hover & {
        transform: scale(1.05);
    }
`;

export const NewBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 16px;
    flex-grow: 1;
`;

export const Eyebrow = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: var(--color-primary-soft);
    color: var(--color-primary);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
`;

export const NewTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.3;
    color: var(--color-text);
    letter-spacing: -0.2px;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const NewText = styled.p`
    font-size: 13.5px;
    font-weight: 500;
    color: var(--color-text-muted);
    line-height: 1.55;
    margin: 0;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

export const ButtonContainer = styled.div`
    margin-top: auto;
    padding-top: 6px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: var(--color-primary);
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.3px;
    transition: var(--transition);

    svg {
        width: 15px;
        height: 11px;
        transition: transform 200ms ease;
    }

    ${NewContainer}:hover & {
        color: var(--color-primary-dark);
    }

    ${NewContainer}:hover & svg {
        transform: translateX(4px);
    }
`;
